module.exports = __webpack_public_path__ + "img/slider-item-boxer.df1b8c78.webp";